import api from '../token';

export const ListProduto = async (payload) => {
  try {
    const response = await api.post('/get',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

